module.exports = __webpack_public_path__ + "img/btn-swiper-play-on-control-02.fd81d8d8.svg";